import React from 'react';
import styles from "./myprofile.module.css"
import ProfileMenu from '../../components/profilemenu/ProfileMenu';
import CustomSeparator from '../../../Website/components/maincomps/breadcrumbs/Breadcrumbs';
import breadcrumbStyle from '../../../Website/components/maincomps/breadcrumbs/breadcrumbs.module.css'


const Myprofile = ({ children }) => {
    return (
        <>
            <div className={breadcrumbStyle.breadcrumbStyle}>
                <CustomSeparator home="Home" type="Dashboard" />
            </div>
            <div className={styles.myprofile}>
                <div className={styles.promenu}>
                    <ProfileMenu />
                </div>

                {children}

            </div>
        </>
    );
};

export default Myprofile;